<template>
    <div class="d-flex flex-fill">
        <DropdownSelect
            class="flex-fill"
            :data="datasource!"
            caption="general.none"
            v-model="value"
            :show-search="datasource.length > 10"
        />
        <ButtonComp
            v-if="false"
            class="flex-grow-0"
            button-type="Add"
            @click="addNewEventTeam"
        />
    </div>
</template>

<script setup lang="ts">
import type { ISelectLineDatasource } from '@/objects/ISelectLineDatasource';
import { ButtonComp, DropdownSelect } from '@/components';
import type { SelectLineValueType } from '@/objects';
import { computed } from 'vue';

const props = withDefaults(
    defineProps<{
        /**
         * The datasource for the select
         */
        datasource: ISelectLineDatasource;
    }>(),
    {},
);

const datasource = computed(() => {
    if (props.datasource.source) {
        return props.datasource.source;
    }
    return Array.from(props.datasource.mapsource?.values() ?? []);
});

/**
 * This should show a popup to add a new event team.
 * TODO: not yet implemented. Will implement this when we implement the eventTeam competitions
 */
const addNewEventTeam = () => {
    console.log('ADD');
};

const value = defineModel<SelectLineValueType>({ required: true });
</script>
